import type { SeparatorProps } from './types'

import * as S from './styles'

export const Separator = ({ spacing = 16, ...rest }: SeparatorProps) => {
  return <S.Separator height={spacing} {...rest} />
}
